import { IPlanoContext } from "./Interfaces/IPlanoContext";
import { PlanoActionKeys, PlanoActionUnion } from "./Plano.Actions";

export const INITIAL_STATE: IPlanoContext = {
  isLoading: false,
  result: {
    data: {} as any,
    success: false,
  },
  planos: {
    data: [],
    success: false,
  },
};

export const PlanoReducers = (
  state = INITIAL_STATE,
  action: PlanoActionUnion
): IPlanoContext => {
  switch (action.type) {
    case PlanoActionKeys.GET_PLANO_SUCCESS:
      return {
        ...state,
        result: action.payload,
      };
    case PlanoActionKeys.GET_ALL_PLANOS_SUCCESS: {
      return {
        ...state,
        planos: action.payload,
      };
    }
    case PlanoActionKeys.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};
